module.exports = __webpack_public_path__ + "static/media/continuous assessment.03d400bc.svg";